import React, { useCallback } from "react";
import { usersPageUpdPassword } from "../reducers/users-page-actions";
import { useToggle } from "react-use";
import { useDispatch } from "react-redux";
import { Body1, EntradaForm, H6 } from "../../../../components";
import { Stack } from "@mui/material";
import * as yup from "yup";

const STR = {
  titlePage: "Alterar senha",
  subtitlePage: "Aqui você pode alterar a senha do usuário.",
  labelPassword: "Senha",
  labelPasswordConfirm: "Confirme a senha",
  placeholderPassword: "Digite a senha",
  placeholderPasswordConfirm: "Confirme a senha",
  errorPassword: "* A senha deve conter ao menos 6 caracteres",
  errorPasswordConfirm: "* Senhas não conferem",
};

const KEYS = {
  password: "senha",
  passwordConfirm: "senhaConfirm",
};

function UsersPageUpdPassword({ id }) {
  const [wait, setWait] = useToggle();
  const dispatch = useDispatch();
  //
  let schemaMessageError = {
    [KEYS.password]: STR.errorPassword,
    [KEYS.passwordConfirm]: STR.errorPasswordConfirm,
  };
  let schemaValidator = {
    [KEYS.password]: yup.string().min(6).required(),
    [KEYS.passwordConfirm]: yup
      .string()
      .oneOf([yup.ref(KEYS.password), null], STR.errorPasswordConfirm)
      .required(),
  };
  //
  const schema = [
    {
      type: "password",
      name: KEYS.password,
      label: STR.labelPassword,
      placeholder: STR.placeholderPassword,
      defaultValue: "",
    },
    {
      type: "password",
      name: KEYS.passwordConfirm,
      label: STR.labelPasswordConfirm,
      placeholder: STR.placeholderPasswordConfirm,
      defaultValue: "",
    },
  ];
  //
  const onSubmit = useCallback(
    (data) => {
      dispatch(
        usersPageUpdPassword(
          {
            id: id,

            senha: data[KEYS.password],
          },
          setWait
        )
      );
    },
    [dispatch, id, setWait]
  );
  schemaValidator = yup.object().shape(schemaValidator);
  //
  return (
    <Stack>
      <H6>{STR.titlePage}</H6>
      <Body1 align="center">{STR.subtitlePage}</Body1>
      <EntradaForm
        schema={schema}
        schemaValidator={schemaValidator}
        schemaMessageError={schemaMessageError}
        onSubmit={onSubmit}
        wait={wait}
      />
    </Stack>
  );
}

export default UsersPageUpdPassword;
